import React from 'react';
import MovieForm from './MovieForm3';
// import Player5 from './Player6';
import { Spin  } from "antd";

let genres = [], countries = [], languages = [], timezones = [];

export default class  ManageAddMovie extends React.Component {
    
  state = {
    uploadID: false, currency: 'USD', fees: 4999, callSave: 0, player: false, loading: false,
  };
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
  }
  openPlayer = (uploadId, cloudFlareId, isTrailer) => {
    console.log('opening player cloudFlareId='+cloudFlareId+' uploadId='+uploadId);
    let sessionValue = this.state.sessionValue;
    let playerObjects = { uploadId: uploadId, userId: 0, movieObj: '', isTrailer: isTrailer, sessionValue: sessionValue };
    this.setState({ player: true, playerObjects: playerObjects, loading: false });
  }
  onClose = () => {
    this.setState({ player: false, playerObjects: null });
  }
  render() {
    let data = this.props.generalInfoData;
    let loader = this.state.loading;
    console.log('uploadId= add movie props='+this.props.movieObj);
    if(data.genres) {
      genres = data.genres;
      countries = data.countries;
      languages = data.languages;
      timezones = data.timezones;
    }
    return (
        <div style={{ marginTop: 40 }}>
            <div style={{ display: loader ? 'flex' : 'none', position: 'fixed', backgroundColor: 'rgba(10, 26, 42, 0.6)', top: 0, bottom: 0, left: 200, right: 0, zIndex: 9999 }}>
              <Spin size='large' style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
            </div>
            <div style={{ marginTop: 40 }}/>  
            <MovieForm addMovieObj={this.props.movieObj} genres={genres} countries={countries} languages={languages} 
              extraInfo={this.props.extraInfo} timezones={timezones} callSave={this.state.callSave} openPlayer={this.openPlayer}
              refreshMoveList={this.props.refreshMoveList} />            
              {/* { this.state.player &&
                <Player5 playerObjects={this.state.playerObjects} setVisibility={this.onClose} userObject={this.props.userObject}
                 onDatabaseEvents={(event) => {  }} />
              } */}
        </div>
  );
  }
}
